module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BWUe6F/images/Cover.jpg?1684305843152",
      "alt": "This image is the cover for the book Abbott: 1973 #1, Abbott: 1973"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Abbott: 1973 #1, Abbott: 1973\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In a new series for fans of Something is Killing the Children and Bitter Root, Saladin Ahmed, the visionary writer behind Miles Morales: Spider-Man, and Sami Kivelä, the acclaimed artist behind Machine Gun Wizards, reunite for this Must Read supernatural thriller. Detroit’s hardest hitting journalist, Elena Abbott, is trying to make a fresh start at a new newspaper...but her deadly past isn’t ready to let go. The city is days away from the historic election of a Black candidate as their new Mayor, but a vicious new group has emerged to destroy him, targeting anyone who supports his campaign or the change he represents. That means Abbott, who discovers the group’s connection to a dangerous dark magic, has been targeted for certain death - unless she embraces her true power as the Lightbringer to save her city.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Saladin Ahmed, Sami Kivela, Mattia Iacono\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0